import type { DescriptionsProps } from "antd";
import { Card, Descriptions } from "antd";

import { IShipmentProductDetailCommonProps } from "types/shipmentProductCollection";

export const AgentAssociation = ({
  isLoading,
  ShipmentProductData,
  title,
}: IShipmentProductDetailCommonProps) => {
  const agentAssociation = ShipmentProductData?.getAgentAssociation();
  const items: DescriptionsProps["items"] = [
    {
      key: "1",
      label: "Association type",
      children: agentAssociation?.getAssociationType(),
    },
    {
      key: "2",
      label: "Unit type",
      children: agentAssociation?.getUnitType(),
    },
    {
      key: "3",
      label: "Rate",
      children: agentAssociation?.getRate(),
    },
    {
      key: "4",
      label: "Weight",
      children: agentAssociation?.getWeight() || "none",
    },
    {
      key: "5",
      label: "Piece",
      children: agentAssociation?.getPiece() || "none",
    },
    {
      key: "6",
      label: "Cbm",
      children: agentAssociation?.getCbm() || "none",
    },
  ];
  return (
    <Card title={title} bordered={false} loading={isLoading}>
      {agentAssociation ? (
        <Descriptions bordered size="small" layout="vertical" items={items} />
      ) : (
        "Agent association not available yet."
      )}
    </Card>
  );
};
